module.exports = __webpack_public_path__ + "img/madera011.cee37f98.jpg";